<template>
  <div>
    <!-- nothing to see here -->
  </div>
</template>

<script>
import vmodelMixin from "~/mixins/vmodelMixin";
import validationMixin from "~/mixins/validationMixin";

export default {
  name: "SpecifiedOrganisationCollectionMethod",
  mixins: [vmodelMixin, validationMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    orgId: {
      type: String,
      required: true
    }
  },
  data: () => ( {
    mutable: null,
    address: {
      orgId: "",
      name: "",
      line1: "",
      line2: "",
      line3: "",
      town: "",
      region: "",
      postcode: "",
      organisation: ""
    }
  } ),
  computed: {
    isValid () {
      let result = true;

      if ( !this.orgId ) {
        result = false;
      }

      return result;
    }
  },
  watch: {
    address: {
      handler () {
        this.copyToMutable();
        this.validate();
      },
      deep: true,
      immediate: true
    },
    mutable: {
      handler ( val ) {
        this.copyFromMutable( val );
      },
      deep: true
    }
  },
  methods: {
    copyToMutable () {
      if ( this.mutable ) {
        this.mutable.orgId = this.orgId;
      }
    },
    copyFromMutable ( mutable ) {
      this.address.orgId = mutable.orgId;
    }
  }
};
</script>

<style lang="less" scoped>

</style>
